import { SchemaTypes } from '@allesauto/graphql';

export const getVehiclePDPData = (
  vehicle: SchemaTypes.Vehicle,
  configuratorVehicle: SchemaTypes.Vehicle | undefined | null
): SchemaTypes.Vehicle => {
  if (!configuratorVehicle) return vehicle;
  return configuratorVehicle;
};
